<template>
    <div id="pixPopup" class="modal fade" role="dialog">
      <div class="modal-dialog profile-confirm-poup">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header confirmpopup-bgcolor p-0">
            <div class="add-record-title">
              <div>
                <span v-if="$i18n.locale === 'Portuguese'">QR code do PIX gerado</span>
                <span v-else>PIX QR Code Generated</span>
              </div>
            </div>
          </div>
          <div class="modal-body confirm-body">
            <div class="subscribe-body" v-if="paymentDetails && paymentDetails.pix">
              <span v-if="$i18n.locale === 'Portuguese'">Abra seu aplicativo bancário, escolha a opção pagar com PIX e escaneie o QR code abaixo. Você também pode pagar mais tarde dentro da janela de tempo recomendada clicando em "<span class="text-bold">Link da fatura</span>" para ver o QR code. Clique em OK para ser redirecionado e rastrear os detalhes do pagamento na seção correspondente da aba "Cobrança".</span>
              <span v-else>Open your bank app, choose pay with PIX option and scan the QR code below. You can also pay later within the recommended time frame by clicking on the “<span class="text-bold">Invoice link</span>” to view the QR code. Click on "OK" to be redirected to track your payment details in payment tracker section under "Billing" Tab.</span>
              <div class="text-center pt-24">
                <img class="qr-code" :src="`data:image/png;base64, ${paymentDetails.pix.encoded_image}`" alt="pix-img"/>
              </div>
              <div class="pt-16 text-center pb-24">
                {{ $t("codeValidity") }} {{ getDate(paymentDetails.pix.expiration_date) }}
              </div>
            </div>
          </div>
          <div class="modal-footer confirmpopup-bgcolor col-xs-12 col-sm-12 d-flex-sm-end">
            <div class="">
              <a type="button" class="btn btn-block cancel-changes" :href="paymentDetails.invoice_url" target="_blank">
                <img src="/static/images/icons/invoice_link.svg" />
                {{ $t("invoiceLink") }}
              </a>
            </div>
            <div class="">
              <button type="button" class="btn btn-block proceed-changes" @click="proceed()">{{ $t("okButton") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
<script>
import $ from 'jquery';
import moment from 'moment';

export default {
  props: [
    'paymentDetails',
  ],
  data() {
    return {
      newToMarket: 'false',
    };
  },
  methods: {
    getDate(date) {
      return this.$i18n.locale === 'Portuguese' ? moment(date).format('DD/MM/YYYY HH:mm:ss') : moment(date).format('MM/DD/YYYY hh:mm:ss');
    },
    closeModal() {
      $('#pixPopup').modal('hide');
      this.$emit('closePopup');
    },
    proceed() {
      $('#pixPopup').modal('hide');
      this.$emit('proceedPix');
      // next popup
    },
  },
};
</script>
  <style scoped>
  label {
      display: inline-block;
      max-width: 100%;
      margin-bottom: 0px !important;
      /* font-weight: 700; */
  }
  .modal-header {
      background-color: #ffffff !important;
      border-bottom: 1px solid #d3d3d3 !important;
      border-top-right-radius: 6px!important;
      border-top-left-radius: 6px!important;
  }
  .modal-header .close {
      background: unset;
      opacity: 1;
      line-height: unset;
      width: unset;
      border-radius: unset;
      color: unset;
      background-color: #ffffff !important;
  }
  .add-record-title {
      display: flex;
      justify-content: space-between;
      font-weight: 600;
      font-size: 20px;
      line-height: 27px;
      color: #1a1a1a;
      padding: 12px 0px 11px 16px;
  }
  .close-icon {
      padding-right: 16px;
  }
  .proceed-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: #333333;
      padding: 16px 0 23px 0;
  }
  .modal-body {
      padding: 25px 55px 0px 24px;
  }
  .market-title {
      font-weight: 400;
      font-size: 16px;
      line-height: 26px;
      color: #3e3e3e;
  }
  label>input[type="radio"] {
      display: none;
  }
  label>input[type="radio"]+*::before {
      content: "";
      display: inline-block;
      vertical-align: bottom;
      width: 18px;
      height: 18px;
      margin-right: 11px;
      margin-bottom: 4px;
      border-radius: 50%;
      border-style: solid;
      border-width: 1px;
      border-color: #00518a;
      border: 2px solid #4d4d4d;
  }
  label>input[type="radio"]:checked+*::before {
      background: radial-gradient(#00518a 0%, #00518a 46%, transparent 51%, transparent);
      border-color: #00518a;
      border: 2px solid #00518a;
  }
  .proceed-changes,
  .proceed-changes:hover {
      background-color: #01518a;
      height: 44px;
      width: auto;
      color: #ffffff;
      font-size: 18px;
      font-weight: 600;
      border-radius: 3px;
      line-height: 22px;
      float: right;
      cursor: pointer;
      padding: 9px 16px;
      text-transform: capitalize;
  }
  .cancel-changes,
  .cancel-changes:hover {
      background-color: #ffffff;
      height: 44px;
      width: auto;
      color: #000;
      font-size: 18px;
      font-weight: 600;
      border-radius: 3px;
      line-height: 22px;
      float: right;
      cursor: pointer;
      padding: 9px 16px;
      border: 1px solid #000001;
  }
  .modal-footer {
      background-color: #ffffff !important;
      padding-right: 0px;
      border: none !important;
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
  }
  .download-btn, .download-btn:hover {
    background: transparent;
    font-size: 14px;
    color: #00518A;
    cursor: pointer;
  }
  .col-gap-8 {
    column-gap: 8px;
  }
  .modal-content {
   border: none;
   border-top-right-radius: 6px!important;
   border-top-left-radius: 6px!important;
   border-bottom-right-radius: 0!important;
   border-bottom-left-radius: 0!important;
  }
  .pb-21 {
   padding-bottom: 21px;
  }
  .radio-buttons {
   padding-left: 19px;
   padding-bottom: 27px;
  }
  @media (min-width: 768px) {
  .modal-dialog {
   width: 700px;
   margin: 30px auto;
  }
  }
  .subscribe-body {
    font-size: 18px;
    color: #333333;
    font-weight: 400;
    font-style: normal;
    line-height: 25px;
  }
  .qr-code {
    width: 160px;
    height: 160px;
  }
  </style>
